import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

const FoodangLoading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        width: "90vw",
        height: "100vh",
        zIndex: 9999,
        bgcolor: "rgba(255, 255, 255, .7);",
        textAlign: "center",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <img src="/foodang.png" width="100" alt="푸댕이" />
        <div>
          <span>데이터를 불러오고 있어요... </span>
          <CircularProgress size={15} />
        </div>
      </Box>
    </Box>
  );
};

export default FoodangLoading;
